export default __webpack_public_path__ + "static/media/star.693ef1cb.svg";